import React, { useEffect } from 'react';
import { CnEllipsis } from '@alife/cn-ui';
import { useI18n } from '@alife/panda-i18n';
import { PanelType } from 'src/types';
import { logCustom } from 'src/utils/tracker';
import './index.scss';
const defaultIcon = 'https://img.alicdn.com/imgextra/i4/O1CN01dz949r1kFa5bUzhIO_!!6000000004654-0-tps-656-128.jpg';
export default (props) => {
    const { data, panelCode } = props;
    useEffect(() => {
        logCustom('EXP_questionnaire', data?.questionnaireUrl, panelCode);
    }, []);
    const $i18n = useI18n();
    return (React.createElement("div", { className: 'cn-intelli-assistant-faction', style: {
            backgroundImage: `url(${data?.questionnaireIcon?.url || defaultIcon})`,
        }, onClick: () => {
            logCustom('CLK_questionnaire', data?.questionnaireUrl, panelCode);
            props.onItemClick(PanelType.questionnaire, data?.questionnaireUrl, panelCode);
        } },
        React.createElement("div", { className: 'cn-intelli-assistant-faction-left' },
            React.createElement("div", { className: 'cn-intelli-assistant-faction-left-title' },
                React.createElement(CnEllipsis, null, $i18n.get({ id: 'SatisfactionSurvey.ued', dm: '满意度调研' }))),
            React.createElement("div", { className: 'cn-intelli-assistant-faction-left-subtitle' },
                React.createElement(CnEllipsis, null, $i18n.get({ id: 'EagerToGetYourComments.ued', dm: '渴望得到您的评价' })))),
        React.createElement("div", { className: 'cn-intelli-assistant-faction-right' })));
};
